import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { MobileOrdonnanceApiService, MobilePatientApiService } from "features";

import { catchError, concatMap, map } from "rxjs/operators";
import { of } from "rxjs";
import {
	LoadPatientOfOrdonnanceDetails,
	LoadPatientOfOrdonnanceDetailsError,
	LoadPatientOfOrdonnanceDetailsSuccess,
	OrdonnanceDetailsActionTypes,
} from "./ordonnance-details.action";

@Injectable()
export class OrdonnanceDetailsEffects {
	constructor(
		private actions$: Actions,
		private patientApi: MobilePatientApiService,
	) {}

	loadPatient$ = createEffect(() =>
		this.actions$.pipe(
			ofType<LoadPatientOfOrdonnanceDetails>(OrdonnanceDetailsActionTypes.LoadPatientOfOrdonnanceDetails),
			concatMap((action) => {
				return this.patientApi.loadPatient(action.payload).pipe(
					map((patient) => {
						return new LoadPatientOfOrdonnanceDetailsSuccess(patient);
					}),
					catchError((err) => {
						return of(new LoadPatientOfOrdonnanceDetailsError(err));
					}),
				);
			}),
			catchError((error) => {
				return of(new LoadPatientOfOrdonnanceDetailsError(error));
			}),
		),
	);
}
